
import { mixins } from "vue-class-component";
import { DateUtilsMixin } from "@/mixins/date-utils-mixin";
import { TableConfig } from '@/types';
import { Getter, State } from 'vuex-class';
import SubSection from '@/components/shared/SubSection.vue';
import ModalSection from '@/components/shared/ModalSection.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DeceasedDonor } from '@/store/deceasedDonors/types';
import { GenericCodeValue } from '@/store/types';
import { AllocationRecipient, AllocationOfferTypeValues, AllocationResponse } from '@/store/allocations/types';

interface AllocationOfferHistoryPageState {
  title: string,
  allocationId: string,
  records: AllocationRecipient[]
}

@Component({
  components: {
    ModalSection,
    SubSection
  }
})
export default class ChecklistHistoryModal extends mixins(DateUtilsMixin) {
  @State(state => state.deceasedDonors.selected) private donor!: DeceasedDonor;
  @State(state => state.currentUser) private currentUser!: any;

  @Getter('selectedAllocation', { namespace: 'allocations' }) private allocation!: any;
  @Getter('offerResponses', { namespace: 'lookups' }) private offerResponses!: GenericCodeValue[];
  @Getter('offerResponseCode', { namespace: 'lookups' }) private offerResponseCode!: (code: string|null) => string;
  @Getter('noOfferReasonCategory', { namespace: 'lookups' }) private noOfferReasonCategory!: (code: string) => string;
  @Getter('noOfferReasonCode', { namespace: 'lookups' }) private noOfferReasonCode!: (category: string, code: string) => string;
  @Getter('offerResponseReason', { namespace: 'allocations' }) private offerResponseReason!: (responseCode: string|null, responseCategoryCode: number|null, reasonCode: number|null, offerResponses: any[], organCode: number) => string|undefined;
  @Getter('getChecklistHistory', { namespace: 'allocations' }) private getChecklistHistory!: any;

  records: any[] = [];

  /**
   * Gets configuration for the vue good table configuation
   *
   * @returns {TableConfig} Offer History Table configuration
   */
  get checklistHistoryTableConfig(): TableConfig {
    return {
      data: this.checklistHistoryRows || [],
      columns: [
        { label: 'Checklist Type', field: 'checklist_type' },
        { label: 'Checklist Status', field: 'confirmed' },
        { label: 'CSC1', field: 'csc1_confirmed_userid' },
        { label: 'CSC1 date stamp signoff', field: 'csc1_confirmed_date' },
        { label: 'CSC2', field: 'csc2_confirmed_userid' },
        { label: 'CSC2 date stamp signoff', field: 'csc2_confirmed_date' },
      ],
      empty: 'There is no checklist history',
    };
  }

  /**
   * Get all rows for table data
   *
   * @returns {any[]} Offer History Table configuration
   */
  get checklistHistoryRows(): any[] {
    // if not an array OR there are no records
    if (!Array.isArray(this.records) || this.records.length <= 0) {
      return [];
    }
    const results: any[] = [];
    const recordsCount = this.records.length;

    this.records.forEach((record: any, index: number) => {
      const row: any = {
        checklist_type: this.$t(index < recordsCount - 2 ? 're' : record.checklist_type),
        confirmed: record.confirmed ? this.$t('confirmed') : this.$t('not confirmed'),

        csc1_confirmed_userid: record.details.csc1_confirmed_userid,
        csc1_confirmed_date: record.details.csc1_confirmed_date ? this.parseDisplayDateTimeUiFromDateTime(record.details.csc1_confirmed_date) : '-',

        csc2_confirmed_userid: record.details.csc2_confirmed_userid,
        csc2_confirmed_date: record.details.csc2_confirmed_date ? this.parseDisplayDateTimeUiFromDateTime(record.details.csc2_confirmed_date) : '-',
      };
      results.push(row);
    });
    return results || [];
  }

  public initializeModal(): void {
    this.records = this.getChecklistHistory;

    const targetModal = this.$refs.checklistHistoryModal as ModalSection;
    targetModal.toggleModal();
  }

  // Toggle modal
  private closeModal(): void {
    (this.$refs.checklistHistoryModal as ModalSection).hideModal();
  }
}
